<script>
import { PageSettings } from '@/api/'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { cloneDeep } from 'lodash'

export default {
  components: {},
  mixins: [FormMixin],
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.service.get().then(response => {
        this.form = response.data
        this.prepareFormCopyToPreventChangesLost()
      })
    },
    onSubmit() {
      this.loading = true
      const service = this.service.update(this.form)
      service
        .then(this.successHandler)
        .then(() => {
          this.formCopy = cloneDeep(this.form)
        })
        .catch(this.errorHandler)
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'General'
        },
        children: [
          new fields.Header({
            text: 'Page default SEO settings',
            type: 'h3'
          }),
          new fields.Header({
            text: 'Settings defined below are used as defaults for pages which does not have SEO tab filled.',
            type: 'h4'
          }),
          new fields.Input({
            label: 'Site meta title for search engines (Google, Bing etc.)',
            modelPath: [this, 'form', 'default_meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label:
              'Site meta description for search engines (Google, Bing etc.)',
            modelPath: [this, 'form', 'default_meta_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Input({
            label: 'Facebook meta title',
            modelPath: [this, 'form', 'default_og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Facebook meta description',
            modelPath: [this, 'form', 'default_og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Facebook image',
            modelPath: [this, 'form', 'default_og_image'],
            onlyShowNormalCrop: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return PageSettings
    }
  }
}
</script>
